import React, {Component} from 'react';
import lang from '../Components/Lang/lang.json';
import Icons from './Icons';

class Messages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: ""
    }

      // To send pop up messages to the user you have to specify a type and
      // a msg. Messages are coded with a "eXX" pattern. Check lang.json
      // to see all the text lines.
  } 
  static getDerivedStateFromProps(props, state){
    clearTimeout();
    let {isOpen, type} = props;
    if (isOpen) {
      return {
        active: "open " + type,
      }
    } else if (!isOpen) {
      return {
        active: ""
      }
    }
  }

  render (){
    if (this.props.username && this.props.msg) {
      let {msg, locale} = this.props;
      return (
        <div className={"msg " + this.state.active}>
          <span>{lang.Messages[msg][locale]}</span>
          <span className="userName">{this.props.username}</span>
        </div>
      )
    } else if (this.props.msg) {
      let {msg, locale} = this.props;
      return (
        <div className={"msg " + this.state.active}>
          <span><Icons name="arrowThin"/></span>
          <span>{lang.Messages[msg][locale]}</span>
        </div>
      )
    } else {
      return(
        <div className={"msg " + this.state.active}></div>
      )
    }
  }
}

export default Messages;


// WEBPACK FOOTER //
// ./src/Containers/Messages.js